<template>
  <div>
    <pop-modal
      :visible="visible"
      :isDrag="true"
      :title="`开具增值税${kpdate.taxClass == 0 ? '专用' : kpdate.taxClass === 1 ? '普通' : '电子普通'}发票`"
      :width="988"
      @cancel="handelCancel"
    >
      <div class="wrap">
        <div class="header">
          <div>请认真核对发票<span>种类、代码、号码</span>是否一致，如不一致请更换纸质发票</div>
          <!-- <div>喇叭</div> -->
        </div>
        <div class="main">
          <div class="main-top">
            <div>
              <a-select default-value="0" style="width: 120px">
                <a-select-option value="0"> 普通开具 </a-select-option>
              </a-select>
            </div>
            <div>
              <!-- v-leftMenu="redMenudata" -->
              <a-button
                type="primary re1"
                v-leftMenu="redMenudata"
                ghost
                v-show="kpdate.taxClass === 0 && invoiceStatus !== 'redMark'"
                >红字</a-button
              >
              <a-button
                type="primary red2"
                ghost
                @click="redMarkShow()"
                v-show="(kpdate.taxClass === 1 || kpdate.taxClass === 3) && invoiceStatus !== 'redMark'"
                >红字</a-button
              >
              <!-- <a-button type="primary" ghost @click="chonghong">冲红</a-button> -->
              <a-button type="primary" ghost :disabled="kpdate.taxClass === 2 || invoiceStatus === 'redMark'"
                >导入</a-button
              >
              <a-button type="primary" ghost :disabled="kpdate.taxClass === 2 || invoiceStatus === 'redMark'"
                >复制</a-button
              >
              <a-button type="primary" ghost :disabled="kpdate.taxClass === 2">暂存</a-button>
              <a-button type="primary" ghost>预览</a-button>
              <a-button type="primary" ghost @click="printSave(3)" :loading="isSaving" v-if="kpdate.taxClass === 3"
                >保存</a-button
              >
              <a-button type="primary" ghost @click="printSave()" :loading="isSaving" v-else>打印</a-button>
            </div>
          </div>
          <div class="main-cont">
            <div
              class="cont-invoice"
              v-show="!isInPrint"
              :class="kpdate.taxClass == 0 ? 'zy' : kpdate.taxClass == 1 ? 'pt' : 'dz'"
            >
              <div class="invoice-header">
                <span :style="{ left: kpdate.taxClass == 3 ? '304px' : '348px' }">{{ enterprise.domainName }}</span>
              </div>
              <div class="invoice-no">
                <div class="version"><span>税收分类编码版本号:39.0</span></div>
                <div>
                  <select name="" id="" class="code">
                    <option value="1">{{ kpdate.taxBillCode }}</option>
                  </select>
                  <select name="" id="" class="number">
                    <option value="1">{{ kpdate.taxBillNo }}</option>
                  </select>
                  <div class="date">
                    <span>{{ enterprise.taxBillDate | filterDate }}</span>
                  </div>
                </div>
              </div>
              <div class="invoice-buyer">
                <div class="left">
                  <div class="relative">
                    <input type="text" v-model="enterprise.buyerName" />
                    <a-icon type="plus-square" class="addImg" @click="showkehu()" />
                  </div>
                  <div class="relative">
                    <input type="text" v-model="enterprise.buyerTaxpayerId" />
                    <a-icon type="plus-square" class="addImg" @click="showkehu()" />
                  </div>
                  <div class="relative">
                    <input type="text" v-model="enterprise.buyerAddress" />
                  </div>
                  <div class="relative">
                    <input type="text" v-model="enterprise.buyerAccounts" />
                  </div>
                </div>
                <div class="right" v-if="kpdate.taxClass === 3">
                  <input type="text" />
                  <input type="text" />
                  <input type="text" />
                </div>
              </div>
              <div class="invoice-table">
                <div class="table-header tab">
                  <div style="flex: 0.3">
                    <input type="checkbox" name="" id="" v-model="allChecked" @change="checkAll()" />
                  </div>
                  <div style="flex: 2.3">货物或应税劳务、服务名称</div>
                  <div style="flex: 1.15">规格型号</div>
                  <div style="flex: 0.6">单位</div>
                  <div style="flex: 0.95">数量</div>
                  <div style="flex: 1.3">单价({{ price == 'taxfree' ? '不含税' : '含税' }})</div>
                  <div style="flex: 1.5">金额({{ price == 'taxfree' ? '不含税' : '含税' }})</div>
                  <div style="flex: 0.5">税率</div>
                  <div style="flex: 1.8">税额</div>
                </div>
                <div
                  class="table-content tab"
                  :class="[data.isDiscount || invoiceStatus === 'redMark' ? 'red' : '']"
                  v-for="(data, i) in kpList"
                  :key="i"
                >
                  <div style="flex: 0.3; text-align: center">
                    <input type="checkbox" name="" id="" v-model="data.checked" @change="checkChange(data, i)" />
                  </div>
                  <!-- 货物或应税劳务、服务名称 -->
                  <div style="flex: 2.3">
                    <div class="relative">
                      <input type="text" v-model="data.alias" :readonly="!onlyQd" />
                      <a-icon type="plus-square" class="addImg" @click="!onlyQd && showGoods(i)" />
                    </div>
                  </div>
                  <!-- 规格型号 -->
                  <div style="flex: 1.15">
                    <input
                      type="text"
                      v-model="data.goodsGauge"
                      :readonly="isDisOnly(data, i)"
                      v-if="!data.isDiscount"
                    />
                  </div>
                  <!-- 单位 -->
                  <div style="flex: 0.6">
                    <input
                      type="text"
                      v-model="data.goodsUnits"
                      :readonly="isDisOnly(data, i)"
                      v-if="!data.isDiscount"
                    />
                  </div>
                  <!-- 数量 -->
                  <div style="flex: 0.95">
                    <input
                      type="number"
                      v-model="data.goodsAmounts"
                      @change="goodsAmountsChange(i)"
                      :readonly="isDisOnly(data, i)"
                      v-if="!data.isDiscount"
                    />
                  </div>
                  <!-- 单价 -->
                  <div style="flex: 1.3">
                    <input
                      type="number"
                      v-model="data.goodsUnitPrice"
                      @change="goodsUnitPriceChange(i)"
                      :readonly="isDisOnly(data, i)"
                      v-if="!data.isDiscount"
                    />
                  </div>
                  <!-- 金额 -->
                  <div style="flex: 1.5">
                    <input
                      type="number"
                      v-model="data.goodsPriceAmounts"
                      @change="taxAmountPayablesChange(i)"
                      :readonly="isDisOnly(data, i)"
                    />
                  </div>
                  <!-- 税率 -->
                  <div style="flex: 0.5">
                    <select
                      v-model="data.goodsTaxRates"
                      @change="rateChange(i)"
                      :disabled="data.goodsName && isDisOnly(data, i)"
                    >
                      <option value="0.13">13%</option>
                      <option value="0.09">9%</option>
                      <option value="0.06">6%</option>
                      <option value="0.05">5%</option>
                      <option value="0.03">3%</option>
                      <option value="0.01">1%</option>
                      <option value="0.00">0%</option>
                      <option value="0.00">免税</option>
                      <option value="0.04">4%</option>
                    </select>
                  </div>
                  <!-- 税额 -->
                  <div style="flex: 1.8"><input type="text" v-model="data.taxAmountPayables" readonly /></div>
                </div>
              </div>
              <div class="invoice-sum">
                <span>￥{{ moneyAmount | tofixed }}</span>
                <span>￥{{ rateMoneyAmount | tofixed }}</span>
              </div>
              <div class="invoice-taxsum">
                <span>{{ moneyAndRate | filterMoney }}</span>
                <span>￥{{ moneyAndRate | tofixed }}</span>
              </div>
              <div class="invoice-saler">
                <div class="left">
                  <input type="text" v-model="enterprise.enterpriseName" />
                  <input type="text" v-model="enterprise.enterpriseTaxpayerId" />
                  <input type="text" v-model="enterprise.enterpriseAddress" />
                  <input type="text" v-model="enterprise.enterpriseAccounts" />
                </div>
                <div class="right">
                  <textarea v-model="enterprise.remake" placeholder="请输入备注信息"></textarea>
                </div>
              </div>
              <div class="invoice-footer">
                <div class="payee"><input type="text" v-model="enterprise.payee" /></div>
                <div class="review"><input type="text" v-model="enterprise.rechecker" /></div>
                <div class="billing">{{ enterprise.drawer }}</div>
              </div>
            </div>
            <!-- 打印页面 -->
            <div
              class="cont-invoice"
              v-show="isInPrint"
              ref="invoice"
              :class="kpdate.taxClass == 0 ? 'zy' : kpdate.taxClass == 1 ? 'pt' : 'dz'"
            >
              <div class="invoice-header">
                <span class="no-print" :style="{ left: kpdate.taxClass == 3 ? '294px' : '340px' }">{{
                  enterprise.domainName
                }}</span>
              </div>
              <div class="invoice-no">
                <div class="version no-print"><span class="no-print">税收分类编码版本号:39.0</span></div>
                <div>
                  <select name="" id="" class="code no-print">
                    <option value="1">{{ kpdate.taxBillCode }}</option>
                  </select>
                  <select name="" id="" class="number no-print">
                    <option value="1">{{ kpdate.taxBillNo }}</option>
                  </select>
                  <div class="date">
                    <span>{{ enterprise.taxBillDate | filterDate }}</span>
                  </div>
                </div>
              </div>
              <div class="invoice-buyer">
                <div class="left">
                  <div class="relative">
                    <input class="unborder" type="text" v-model="enterprise.buyerName" />
                    <a-icon type="plus-square" class="addImg no-print" @click="!onlyQd && showGoods(i)" />
                  </div>
                  <div class="relative">
                    <input class="unborder" type="text" v-model="enterprise.buyerTaxpayerId" />
                    <a-icon type="plus-square" class="addImg no-print" @click="!onlyQd && showGoods(i)" />
                  </div>
                  <div class="relative">
                    <input class="unborder" type="text" v-model="enterprise.buyerAddress" />
                  </div>
                  <div class="relative">
                    <input class="unborder" type="text" v-model="enterprise.buyerAccounts" />
                  </div>
                </div>
                <div class="right" v-if="kpdate.taxClass === 3">
                  <input type="text" />
                  <input type="text" />
                  <input type="text" />
                </div>
              </div>
              <div class="invoice-table unborder" style="min-height: 189px">
                <div class="table-header tab no-print">
                  <!-- <div style="flex: 0.3">
                    <input type="checkbox" name="" id="" v-model="allChecked" @change="checkAll()" />
                  </div> -->
                  <div class="no-print" style="flex: 2.3">货物或应税劳务、服务名称</div>
                  <div class="no-print" style="flex: 1.15">规格型号</div>
                  <div class="no-print" style="flex: 0.6">单位</div>
                  <div class="no-print" style="flex: 0.95">数量</div>
                  <div class="no-print" style="flex: 1.3">单价({{ price == 'taxfree' ? '不含税' : '含税' }})</div>
                  <div class="no-print" style="flex: 1.5">金额({{ price == 'taxfree' ? '不含税' : '含税' }})</div>
                  <div class="no-print" style="flex: 0.5">税率</div>
                  <div class="no-print" style="flex: 1.8">税额</div>
                </div>
                <div class="table-content tab" v-for="(data, i) in kpList" :key="i">
                  <!-- <div style="flex: 0.3; text-align: center">
                    <input type="checkbox" name="" id="" v-model="data.checked" @change="checkChange(data, i)" />
                  </div> -->
                  <!-- 货物或应税劳务、服务名称 -->
                  <div style="flex: 2.3">
                    <div class="relative">
                      <input class="unborder" type="text" v-model="data.goodsName" :readonly="!onlyQd" />
                      <a-icon type="plus-square" class="addImg no-print" @click="!onlyQd" />
                    </div>
                  </div>
                  <!-- 规格型号 -->
                  <div style="flex: 1.15">
                    <input class="unborder" type="text" v-model="data.goodsGauge" readonly v-if="!data.isDiscount" />
                  </div>
                  <!-- 单位 -->
                  <div style="flex: 0.6">
                    <input class="unborder" type="text" v-model="data.goodsUnits" readonly v-if="!data.isDiscount" />
                  </div>
                  <!-- 数量 -->
                  <div style="flex: 0.95">
                    <input
                      class="unborder"
                      type="number"
                      v-model="data.goodsAmounts"
                      @change="goodsAmountsChange(i)"
                      readonly
                      v-if="!data.isDiscount"
                    />
                  </div>
                  <!-- 单价 -->
                  <div style="flex: 1.3">
                    <input
                      class="unborder"
                      type="number"
                      v-model="data.goodsUnitPrice"
                      @change="goodsUnitPriceChange(i)"
                      readonly
                      v-if="!data.isDiscount"
                    />
                  </div>
                  <!-- 金额 -->
                  <div style="flex: 1.5">
                    <input
                      class="unborder"
                      type="number"
                      v-model="data.goodsPriceAmounts"
                      @change="taxAmountPayablesChange(i)"
                      readonly
                    />
                  </div>
                  <!-- 税率 -->
                  <div style="flex: 0.5">
                    <select
                      class="unborder"
                      style="text-align: center"
                      v-model="data.goodsTaxRates"
                      @change="rateChange(i)"
                      :disabled="data.goodsName && isDisOnly(data, i)"
                    >
                      <option value="0.13">13%</option>
                      <option value="0.09">9%</option>
                      <option value="0.06">6%</option>
                      <option value="0.05">5%</option>
                      <option value="0.03">3%</option>
                      <option value="0.01">1%</option>
                      <option value="0.00">0%</option>
                      <option value="0.00">免税</option>
                      <option value="0.04">4%</option>
                    </select>
                  </div>
                  <!-- 税额 -->
                  <div style="flex: 1.8">
                    <input
                      class="unborder"
                      type="text"
                      v-model="data.taxAmountPayables"
                      readonly
                      style="text-align: center"
                    />
                  </div>
                </div>
              </div>
              <div class="invoice-sum">
                <span>￥{{ moneyAmount | tofixed }}</span>
                <span>￥{{ rateMoneyAmount | tofixed }}</span>
              </div>
              <div class="invoice-taxsum">
                <span>{{ moneyAndRate | filterMoney }}</span>
                <span>￥{{ moneyAndRate | tofixed }}</span>
              </div>
              <div class="invoice-saler">
                <div class="left">
                  <input class="unborder" type="text" v-model="enterprise.enterpriseName" />
                  <input class="unborder" type="text" v-model="enterprise.enterpriseTaxpayerId" />
                  <input class="unborder" type="text" v-model="enterprise.enterpriseAddress" />
                  <input class="unborder" type="text" v-model="enterprise.enterpriseAccounts" />
                </div>
                <div class="right">
                  <textarea class="unborder" v-model="enterprise.remake" placeholder="请输入备注信息"></textarea>
                </div>
              </div>
              <div class="invoice-footer">
                <div class="payee"><input class="unborder" type="text" v-model="enterprise.payee" /></div>
                <div class="review"><input class="unborder" type="text" v-model="enterprise.rechecker" /></div>
                <div class="billing">{{ enterprise.drawer }}</div>
              </div>
            </div>
            <div class="cont-op">
              <a-button type="primary" ghost @click="addList('fp')">增行</a-button>
              <a-button type="primary" ghost @click="delList()">减行</a-button>
              <a-button
                type="primary"
                ghost
                :disabled="invoiceStatus === 'redMark' || kpdate.taxClass === 2"
                @click="insertList()"
                >插行</a-button
              >
              <a-button
                type="primary"
                ghost
                :disabled="invoiceStatus === 'redMark' || kpdate.taxClass === 2"
                @click="discount()"
                >折扣</a-button
              >
              <a-button type="primary" ghost @click="priceChange()">含税</a-button>
              <a-button type="primary" ghost :disabled="invoiceStatus === 'redMark'" @click="showDetailed()"
                >清单</a-button
              >
              <a-button type="primary" ghost>客户信息</a-button>
            </div>
          </div>
        </div>
      </div>
    </pop-modal>
    <!-- 折扣弹窗 -->
    <pop-modal
      :visible="discountShow"
      :isDrag="true"
      :title="`添加折扣`"
      :width="600"
      :height="50"
      @cancel="discountCancel"
    >
      <div class="discountWrap">
        <div class="row">
          <div class="left">已选商品行数</div>
          <div class="right light-blue">{{ selectedData.length }}</div>
        </div>
        <div class="row">
          <div class="left">商品金额</div>
          <div class="right light-blue">{{ disGoodsAmount | addPrefix }}</div>
        </div>
        <div class="row">
          <div class="left">折扣率（%）</div>
          <div class="right">
            <input type="text" placeholder="请输入折扣率" v-model="discountRate" @input="disCRChange" />
          </div>
        </div>
        <div class="row">
          <div class="left">折扣金额（￥）</div>
          <div class="right">
            <input type="text" placeholder="请输入折扣金额" v-model="discountAmount" @input="disCAChange" />
          </div>
        </div>
      </div>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'center',
          zIndex: 1,
        }"
      >
        <a-button style="margin: 0 20px" type="primary" :disabled="isDiscountSubmit" @click="disSubmit">确认</a-button>
        <a-button style="margin: 0 20px" type="primary" @click="discountCancel">取消</a-button>
      </div>
    </pop-modal>
    <!--客户编码弹窗-->
    <custom-no ref="CustomNoForm" @emitRowKey="emitRowCustom" width="900px" :height="100"></custom-no>
    <!-- 商品编码弹窗 -->
    <goods-no ref="GoodsNoForm" @emitRowKey="emitRowGoods" width="900px" :height="100"></goods-no>
    <!-- 清单 -->
    <detailed ref="detailedFrom" @complete="complete"></detailed>
    <!-- 红字 -->
    <red-mark ref="redMarkForm" @mapDataToInvoice="mapDataToInvoice(arguments)"></red-mark>
    <!-- 打印弹窗 -->
    <print ref="printModal" @printFp="printFpChange('Y')" @cancelFPrintFp="printFpChange('N')"></print>
    <pop-modal
      :visible="eleInvoiceShow"
      :isDrag="true"
      title="温馨提示"
      :width="500"
      :height="50"
      @cancel="closeEleInvoice()"
    >
      <div class="eleInvocie">
        <div class="eHeader">发票开具成功</div>
        <div class="QRcode">
          <img src="@/assets/QRcode.png" alt="" width="100%" />
        </div>
        <div class="eFooter">
          <a-button type="primary" @click="keepOpen(kpdate.taxClass)">继续开具</a-button>
          <a-button type="primary">发送邮件</a-button>
        </div>
      </div>
    </pop-modal>
    <!-- 红字信息表 -->
    <info-sheet-repair ref="infoSheetRepair" @mapDataToInvoice="mapDataToInvoice(arguments)"></info-sheet-repair>
  </div>
</template>

<script>
import Urls from '@/utils/globel.js'
import { parseParam, checkObjectOfNull, keepTwoDecimalFull, changeNumMoneyToChinese } from '@/utils/util'
import { mapGetters, mapActions } from 'vuex'
// import ossService from '@/utils/oss.service'
// import { environment } from '@/utils/oss.env'
import Utils from '@/utils/oss.util'
import CustomNo from '../../systemSet/customNo.vue'
import GoodsNo from '../../systemSet/goodsNo.vue'
import Detailed from './Detailed.vue'
import RedMark from './RedMarks.vue'
import Print from '@/components/Print/print.vue'
import infoSheetRepair from '../infoSheet/infoSheetRepair.vue'
import { dynamicImg } from '@/utils/dynamicImg'
import _ from 'lodash'

export default {
  components: {
    CustomNo,
    GoodsNo,
    Detailed,
    RedMark,
    Print,
    infoSheetRepair,
  },
  data() {
    return {
      dynamicImg,
      visible: false,
      discountShow: false,
      kpdate: {
        taxClass: 0,
        isShow: false,
        icManageId: '',
        taxBillCode: '',
        taxBillNo: '',
      },
      enterprise: {
        buyerAccounts: '',
        buyerAddress: ' ',
        buyerName: '',
        buyerTaxpayerId: '',
        domainName: '',
        enterpriseAccounts: '',
        enterpriseAddress: '',
        enterpriseName: '',
        enterpriseTaxpayerId: '',
        taxBillDate: '',
        drawer: '',
      },
      selectedData: [],
      allChecked: false,
      detailId: '',
      onlyQd: false,
      detailedList: [],
      kpList: [],
      price: 'taxfree',
      moneyAmount: '',
      rateMoneyAmount: '',
      moneyAndRate: '',
      taskData: {},
      invoiceStatus: '',
      isSaving: false,
      redMenudata: [
        {
          type: 'li',
          title: '直接开具',
          func: () => {
            this.$error({
              title: '错误',
              content:
                '根据税务机关要求，在线时不能使用"直接开具"方式开具红字增值税专用发票，请您选择"导入红字发票信息表"或"导入网络下载导入红字发票信息表"开具方式',
            })
          },
        },
        {
          type: 'li',
          title: '导入红字发票信息表',
          func: () => {},
        },
        {
          type: 'li',
          title: '导入网络下载导入红字发票信息表',
          func: () => this.$refs.infoSheetRepair.show('other'),
        },
      ],
      eleInvoiceShow: false,
      isInPrint: false,
      // 折扣
      discountRate: '', // 折扣税率
      discountAmount: '', // 折扣金额
      disGoodsAmount: 0, // 商品金额
      isDiscountSubmit: false,
    }
  },
  computed: {
    ...mapGetters('practice', ['TASK_DATA', 'ENTERPRISE', 'LOGIN_INFO']),
  },
  filters: {
    filterDate(v) {
      const dateArr = v.split('-')
      return v.length ? `${dateArr[0]}年${dateArr[1]}月${dateArr[2]}日` : ''
    },
    filterMoney(money) {
      return changeNumMoneyToChinese(money)
    },
    tofixed(v) {
      return v ? v.toFixed(2) : '0.00'
    },
    addPrefix(v) {
      return v ? '￥' + v : v
    },
  },
  methods: {
    async show(taxClass) {
      this.kpdate.taxClass = taxClass
      this.kpdate.icManageId = ''
      const isOpen = await this.nextFptk()
      if (isOpen) {
        this.generateInvoice()
        this.addList('fp')
        this.amountMoney()
        this.visible = true
      }
    },
    handelCancel() {
      this.visible = false
      this.kpdate.taxClass = ''
    },
    discountCancel() {
      this.discountShow = false
    },
    // 红字
    redMarkShow() {
      this.$refs.redMarkForm.show()
    },
    // 冲红
    // chonghong() {},
    // 初始化发票数据
    initVoiceData() {
      this.kpList = []
      this.selectedData = []
      this.price = 'taxfree'
      this.moneyAmount = ''
      this.rateMoneyAmount = ''
      this.moneyAndRate = ''
    },
    // 多选
    checkAll() {
      if (this.allChecked) {
        this.kpList.forEach((data, i) => {
          data.checked = true
          this.selectedData.push(data)
        })
      } else {
        this.initSelected()
        this.kpList.forEach((v) => (v.checked = false))
      }
    },
    checkChange(data, i) {
      if (data.checked) {
        // data.checked = true
        this.selectedData.push(data)
      } else {
        // data.checked = false
        this.selectedData = this.selectedData.filter((v) => v.checked)
      }
      this.allChecked = this.selectedData.length === this.kpList.length
    },
    // 初始化全选
    initSelected() {
      this.selectedData = []
      this.allChecked = false
    },
    // 添加行
    addList(type) {
      if (type === 'fp') {
        if (this.kpList.length === 8) {
          return
        }
        if (this.onlyQd) {
          this.$message.warning({
            title: '警告',
            content: '请到清单里面进行操作!',
          })
          return
        }
        this.kpList.splice(this.kpList.length + 1, 0, this.initFP())
      } else {
        this.detailedList.splice(this.detailedList.length + 1, 0, this.initFP())
      }
    },
    // 删除行
    delList(type) {
      if (!this.selectedData.length) {
        this.$info({
          title: '提示',
          content: '请勾选要删除的商品行',
        })
        return
      }
      for (let i = 0; i < this.selectedData.length; i++) {
        if (this.selectedData[i].hasDisCount) {
          this.$confirm({
            title: '提示',
            content: '您将要删除的商品行有折扣行，删除此行也可能将删除折扣行。您要继续吗？',
            onOk: () => {
              this.deleSelf(this.kpList)
              this.initSelected()
              this.amountMoney()
            },
            onCancel: () => false,
          })
          return
        }
        if (this.selectedData[i].isDiscount) {
          this.$confirm({
            title: '提示',
            content: '您将要删除的商品行为折扣行，删除此行将取消上行商品的折扣。您要继续吗？',
            onOk: () => {
              this.deleSelf(this.kpList)
              this.initSelected()
              this.amountMoney()
            },
            onCancel: () => false,
          })
          return
        }
      }
      this.deleSelf(this.kpList)
      this.initSelected()
      this.amountMoney()
    },
    deleSelf(arr) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].checked) {
          if (arr[i].hasDisCount) {
            arr.splice(i, 2)
            i -= 2
            continue
          }
          if (arr[i].isDiscount) {
            arr[i - 1].hasDisCount = false
          }
          arr.splice(i, 1)
          i--
        }
      }
    },
    // 插入行
    insertList() {
      if (!this.selectedData.length) {
        this.$info({
          title: '提示',
          content: '请先选择要插入行的位置!',
        })
        return
      }
      if (this.selectedData.some((v) => v.hasDisCount) || this.selectedData.some((v) => v.isDiscount)) {
        this.$info({
          title: '提示',
          content: '当前行有折扣行，不能插入!',
        })
        return
      }
      this.insertSelf(this.kpList)
      this.initSelected()
      this.amountMoney()
    },
    insertSelf(arr) {
      arr.forEach((v, index) => {
        if (v.checked) {
          if (arr.length < 8) {
            arr.splice(index, 0, this.initFP())
          }
          v.checked = false
          this.insertSelf(arr)
        }
      })
    },
    // 添加折扣
    discount() {
      if (!this.selectedData.length) {
        this.$info({
          title: '提示',
          content: '请勾选要进行折扣的商品行',
        })
        return
      }
      if (this.selectedData.length > 4) {
        this.$info({
          title: '提示',
          content: '折扣行数与商品行数总和超过商品明细行数上线当前可折扣的最大行数为3行',
        })
        return
      }
      if (!this.selectedData.every((v) => v.goodsPriceAmounts)) {
        this.$error({
          title: '提示',
          content: '被折扣商品行中存在金额为空的记录，不能添加折扣',
        })
        return
      }
      if (!this.selectedData.every((v) => v.alias)) {
        this.$error({
          title: '提示',
          content: '被折扣商品行中存在商品为空的记录，不能添加折扣',
        })
        return
      }
      for (let i = 0; i < this.selectedData.length; i++) {
        if (this.selectedData[i].hasDisCount) {
          this.$error({
            title: '提示',
            content: '已经折扣的商品行不能再进行折扣',
          })
          return
        }
        if (this.selectedData[i].isDiscount) {
          this.$error({
            title: '提示',
            content: '折扣行不能再进行折扣！',
          })
          return
        }
      }
      this.disGoodsAmount = this.selectedData.reduce((pre, cur) => {
        return Number(cur.goodsPriceAmounts) + pre
      }, 0)
      this.discountRate = ''
      this.discountAmount = ''
      this.discountShow = true
    },
    disCRChange(v) {
      // 折扣金额 = 商品金额 * 折扣率
      const value = Number(v.target.value)
      if (value > 100) {
        this.$error({
          title: '错误',
          content: '折扣率不能大于100%',
        })
        this.isDiscountSubmit = true
        return
      }
      this.isDiscountSubmit = false
      this.discountAmount = (value / 100) * Number(this.disGoodsAmount)
    },
    disCAChange(v) {
      // 折扣率 = 折扣金额 / 商品金额
      const value = Number(v.target.value)
      if (value > this.disGoodsAmount) {
        this.$error({
          title: '错误',
          content: '折扣金额不能大于被折扣商品合计金额',
        })
        this.isDiscountSubmit = true
        return
      }
      this.isDiscountSubmit = false
      this.discountRate = ((value / Number(this.disGoodsAmount)) * 100).toFixed(2)
    },
    //
    isDisOnly(data, i) {
      return data.isDiscount || (this.kpList[i + 1] && this.kpList[i + 1].isDiscount)
    },
    // 添加折扣确认
    disSubmit() {
      this.discountInsert(this.kpList)
      this.initSelected()
      this.discountCancel()
      this.amountMoney()
    },
    // 插入添加折扣
    discountInsert(arr) {
      arr.forEach((v, index) => {
        if (v.checked) {
          if (arr.length < 8) {
            const fpData = this.initFP('discount')
            const discountRate = ((this.discountAmount / Number(this.disGoodsAmount)) * 100) / 100
            v.hasDisCount = true
            fpData.alias = v.alias
            fpData.goodsName = v.goodsName
            fpData.goodsCodeName = v.goodsCodeName
            fpData.goodsPriceAmounts = (-(v.goodsUnitPrice * v.goodsAmounts * discountRate)).toFixed(2) // 金额 = 父级单价 * 父级数量 * 折扣率
            fpData.goodsTaxRates = v.goodsTaxRates // 税率
            fpData.taxAmountPayables = (-(v.goodsUnitPrice * v.goodsAmounts * discountRate * v.goodsTaxRates)).toFixed(
              2
            ) // 税额 = 当前金额 * 当前税率 向下取整保留两位小数
            arr.splice(index + 1, 0, fpData)
          }
          v.checked = false
          this.discountInsert(arr)
        }
      })
    },
    // 是否含税切换
    priceChange() {
      const list = this.kpList
      if (list == null || list.length < 1) {
        this.$info({
          title: '提示',
          content: '数据为空!',
        })
        return
      }
      this.price = this.price === 'taxfree' ? 'unit' : 'taxfree'
      for (let i = 0; i < list.length; i++) {
        if (list[i].goodsTaxRates !== null || list[i].goodsTaxRates !== 0) {
          const num = (100 + list[i].goodsTaxRates * 100) / 100
          const UnitPrice = list[i].goodsUnitPrice
          const PriceAmounts = list[i].goodsPriceAmounts
          // 第一个计算式为不含税，第二个为含税
          // 如果列表为折扣列表，则不进行单价计算
          if (!list[i].isDiscount) {
            list[i].goodsUnitPrice =
              this.price === 'taxfree' ? Number((UnitPrice / num).toFixed(5)) : Number((UnitPrice * num).toFixed(5))
          }
          list[i].goodsPriceAmounts =
            this.price === 'taxfree' ? Number((PriceAmounts / num).toFixed(2)) : Number((PriceAmounts * num).toFixed(2))
        }
      }
      this.amountMoney()
    },
    // 初始化发票
    initFP(type) {
      const studentReportTaxBList = {
        goodsCodeId: '',
        goodsCodeName: '',
        goodsName: '',
        goodsGauge: '',
        goodsUnits: '',
        goodsAmounts: '',
        // 不含税单价
        goodsUnitPrice: '',
        // 含税单价
        unitprice: '',
        goodsPriceAmounts: '',
        unitmoney: '',
        goodsTaxRates: '0.13',
        taxAmountPayables: '',
        hasTax: '',
        alias: '',
        checked: false, // 是否被选中
        isDiscount: type === 'discount', // 是否为折扣行
        hasDisCount: false, // 是否含有折扣行
      }
      return studentReportTaxBList
    },
    // 进行下一个开票
    async nextFptk() {
      this.initVoiceData()
      const params = parseParam({
        taxClass: this.kpdate.taxClass,
        icManageId: this.kpdate.icManageId ? this.kpdate.icManageId : '',
      })
      const res = await this.$http.post(`${Urls.openInvoice}&${params}`)
      if (res) {
        this.kpdate.icManageId = res.icManageId
        this.kpdate.taxBillNo = res.taxBillNo
        this.kpdate.taxBillCode = res.taxBillCode
        this.invoiceStatus = ''
        return true
      } else {
        return false
      }
    },
    // 获取 enterprise 信息
    async generateInvoice() {
      const task = await this.getTaskByInvoice()
      if (checkObjectOfNull(task)) {
        return
      } else {
        this.taskData = task
      }
      console.log(this.taskData)
      const params = parseParam({
        moduleId: this.taskData.id,
        icManageId: this.kpdate.icManageId,
        taxBillNo: this.kpdate.taxBillNo,
      })
      const res = await this.$http.post(`${Urls.generateInvoice}&${params}`)
      if (res) {
        this.detailId = res.detailId
        this.enterprise = res.enterprise
        this.enterprise.domainName = this.ENTERPRISE.domainName
        // this.enterprise.taxBillDate =
      }
    },
    // 显示客户编码模块
    showkehu() {
      this.$refs.CustomNoForm.show('module')
    },
    emitRowCustom(val) {
      this.$refs.CustomNoForm.handelCancel()
      const data = val[0]
      this.enterprise.buyerName = data.name
      this.enterprise.buyerTaxpayerId = data.taxPayerId
      this.enterprise.buyerAddress = data.address
      this.enterprise.buyerAccounts = data.accounts
      this.$forceUpdate()
    },
    // 显示商品编码模块
    showGoods(index, type) {
      if (type === 'qd') {
        this.goodModalShow = true
        this.goodsIndex = index
      } else {
        this.$refs.GoodsNoForm.show('module')
        this.goodsIndex = index
        // if (this.kpList[0].alias === '(详见销货清单)') {
        //   this.$message.warning({ title: '提示', content: '请到清单里面进行操作!' })
        // } else {
        //   this.$refs.GoodsNoForm.show('module')
        //   this.goodsIndex = index
        // }
      }
    },
    emitRowGoods(val) {
      this.$refs.GoodsNoForm.handelCancel()
      const data = val[0]
      this.kpList[this.goodsIndex].goodsAmounts = null
      this.kpList[this.goodsIndex].goodsName = data.name
      this.kpList[this.goodsIndex].goodsCodeId = data.goodsCodeId
      this.kpList[this.goodsIndex].goodsCodeName = data.goodsCodeName
      this.kpList[this.goodsIndex].goodsGauge = data.guiGe
      this.kpList[this.goodsIndex].goodsUnits = data.units
      this.kpList[this.goodsIndex].goodsUnitPrice = parseFloat(data.unitPrice ? data.unitPrice : '0.00')
      this.kpList[this.goodsIndex].goodsTaxRates = parseFloat(data.taxRate)
      this.kpList[this.goodsIndex].haveTax = data.haveTax
      this.kpList[this.goodsIndex].alias = '*' + data.goodsCodeName + '*' + data.name
    },
    /**
     * 数量变化
     * @param i
     * goodsAmounts 数量  goodsUnitPrice 单价  goodsPriceAmounts  金额  taxAmountPayables 税额   goodsTaxRates 税率
     */
    goodsAmountsChange(i) {
      const listItem = this.kpList[i]
      // 单价 和金额为空时 不做操作
      if (!listItem.goodsUnitPrice && !listItem.goodsPriceAmounts) return
      if (listItem.goodsUnitPrice == null && listItem.goodsPriceAmounts != null) {
        // 单价为空 金额不为空 计算单价
        this.calcUnitPrice(i)
      }
      this.calcPriceAmounts(i) // 计算金额
      this.rateChange(i)
      this.amountMoney()
    },
    /**
     * 单价变化
     * @param i
     * goodsAmounts 数量  goodsUnitPrice 单价  goodsPriceAmounts  金额  taxAmountPayables 税额   goodsTaxRates 税率
     */
    goodsUnitPriceChange(i) {
      const listItem = this.kpList[i]
      // 数量 和 金额 为空时 不做操作
      if (!listItem.goodsAmounts && !listItem.goodsPriceAmounts) return
      // 数量为空 金额不为空 计算数量
      if (listItem.goodsAmounts == null && listItem.goodsPriceAmounts != null) {
        this.calcAmounts(i) // 计算数量
      }
      listItem.goodsUnitPrice = Number(listItem.goodsUnitPrice)
      this.calcPriceAmounts(i) // 计算金额
      this.rateChange(i)
      this.amountMoney()
    },
    /**
     * 金额改变
     * goodsAmounts 数量  goodsUnitPrice 单价  goodsPriceAmounts  金额  taxAmountPayables税额   goodsTaxRates 税率
     * @param i
     */
    taxAmountPayablesChange(i) {
      const listItem = this.kpList[i]
      // 数量 和单价为空时 不做操作
      if (!listItem.goodsAmounts && !listItem.goodsUnitPrice) return
      // 数量为空 单价不为空 计算数量
      if (listItem.goodsAmounts == null && listItem.goodsUnitPrice != null) {
        this.calcAmounts(i) // 计算数量
      }
      listItem.goodsPriceAmounts = Number(listItem.goodsPriceAmounts).toFixed(2) // 转换金额为小数点后两位
      this.calcUnitPrice(i) // 计算单价
      this.rateChange(i)
      this.amountMoney()
    },
    // 计算数量
    calcAmounts(i) {
      const listItem = this.kpList[i]
      listItem.goodsAmounts = keepTwoDecimalFull(listItem.goodsPriceAmounts / listItem.goodsUnitPrice) // 计算数量
    },
    // 计算单价
    calcUnitPrice(i) {
      const listItem = this.kpList[i]
      listItem.goodsUnitPrice = (listItem.goodsPriceAmounts / listItem.goodsAmounts).toFixed(2) // 计算单价
    },
    // 计算金额
    calcPriceAmounts(i) {
      const listItem = this.kpList[i]
      listItem.goodsPriceAmounts = keepTwoDecimalFull(listItem.goodsUnitPrice * listItem.goodsAmounts).toFixed(2) // 计算金额
    },
    // 计算税额
    rateChange(i) {
      const listItem = this.kpList[i]
      if (this.price === 'taxfree') {
        listItem.taxAmountPayables = keepTwoDecimalFull(listItem.goodsPriceAmounts * listItem.goodsTaxRates).toFixed(2) // 税额 等于金额*税率
      } else {
        // 税额为含税时应该计算不含税金额的税率
        const num = (100 + listItem.goodsTaxRates * 100) / 100
        const s = listItem.goodsUnitPrice
        const goodsUnitPrice = keepTwoDecimalFull(s / num).toFixed(2)
        const goodsPriceAmounts = (Number(goodsUnitPrice) * listItem.goodsAmounts).toFixed(2)
        listItem.taxAmountPayables = (Number(goodsPriceAmounts) * listItem.goodsTaxRates).toFixed(2)
      }
    },
    // 计算总额
    amountMoney() {
      this.moneyAmount = 0
      this.rateMoneyAmount = 0
      this.moneyAndRate = 0
      for (let i = 0; i < this.kpList.length; i++) {
        if (this.price === 'taxfree') {
          this.moneyAmount += Number(this.kpList[i].goodsPriceAmounts)
          this.rateMoneyAmount += Number(this.kpList[i].taxAmountPayables)
        } else {
          this.moneyAmount += Number(this.kpList[i].goodsPriceAmounts)
          this.rateMoneyAmount += Number(this.kpList[i].taxAmountPayables)
        }
      }
      if (this.price === 'taxfree') {
        this.moneyAndRate = Number((this.moneyAmount + this.rateMoneyAmount).toFixed(2))
      } else {
        this.moneyAndRate = Number(this.moneyAmount.toFixed(2))
      }
    },
    // 显示 清单
    showDetailed() {
      const param = {
        enterprise: this.enterprise,
        kpList: this.kpList,
        kpdate: this.kpdate,
      }
      this.$refs.detailedFrom.show(param)
    },
    // 清单 完成按钮
    complete(detailedList) {
      this.kpList = [this.initFP()]
      this.detailedList = detailedList
      this.kpList[0].alias = '(详见销货清单)'
      this.onlyQd = true
    },
    // 清单 转发票按钮
    transfrom(list) {
      this.kpList = list
      this.onlyQd = false
    },
    // 红字信息传递到发票
    redInfoToInvoice(data) {
      this.enterprise.buyerName = data.buyerName
      this.enterprise.buyerTaxpayerId = data.buyerTaxpayerId
      this.enterprise.buyerAddress = data.buyerAddress
      this.enterprise.buyerAccounts = data.buyerAccounts
      this.moneyAmount = keepTwoDecimalFull(parseFloat(data.totalGoodsPrices))
      this.rateMoneyAmount = keepTwoDecimalFull(parseFloat(data.totalTaxPays))
      this.moneyAndRate = this.moneyAmount + this.rateMoneyAmount
      this.enterprise.enterpriseName = data.enterpriseName
      this.enterprise.enterpriseTaxpayerId = data.enterpriseTaxpayerId
      this.enterprise.enterpriseAddress = data.enterpriseAddress
      this.enterprise.enterpriseAccounts = data.enterpriseAccounts
      this.enterprise.remake = data.remark
      this.enterprise.drawer = data.drawer
      this.enterprise.rechecker = data.rechecker
      this.enterprise.payee = data.payee
      this.isMenu = data.isMenu
      this.kpList = this.transChange(data.studentReportTaxBList)
      this.invoiceStatus = 'redMark'
    },
    // 获取负数发票并映射到开票窗口
    async mapDataToInvoice(arg) {
      console.log(arg)
      let params
      const type = arg[0]
      const item = arg[1]
      if (type === 'zjkj') {
        // 直接开具
        params = parseParam({
          tabPipeNum: this.tabCode,
          taxBillCode: this.hzTaxBillCode,
          taxBillNo: this.hzTaxBillNo,
        })
      } else if (type === 'xxbkj') {
        // 信息表开具
        params = parseParam({
          tabPipeNum: item.tabPipeNum,
          taxBillCode: item.taxBillCode,
          taxBillNo: item.taxBillNo,
        })
        this.visible = true
      } else if (type === 'ptzjkj') {
        //
        params = parseParam({
          taxBillCode: item.taxBillCode,
          taxBillNo: item.taxBillNo,
        })
      }
      const res = await this.$http.post(`${Urls.getNegInvoice}&${params}`)
      if (res) {
        this.redInfoToInvoice(res.data)
      } else if (res.statusCode === '301') {
        this.$error({
          title: '警告',
          content: res.msg,
        })
      }
    },
    // 红字开票清单的税率转换以及List重新编排
    transChange(list) {
      const listData = []
      for (let i = 0; i < list.length; i++) {
        const rate = parseFloat(list[i].goodsTaxRates.replace('%', ''))
        const sublist = {
          alias: '*' + list[i].goodsCodeName + '*' + list[i].goodsName,
          goodsCodeId: list[i].goodsCodeId,
          goodsCodeName: list[i].goodsCodeName,
          goodsName: list[i].goodsName,
          goodsGauge: list[i].goodsGauge,
          goodsUnits: list[i].goodsUnits,
          goodsAmounts: keepTwoDecimalFull(parseFloat(list[i].goodsAmounts)),
          // 不含税单价
          goodsUnitPrice: keepTwoDecimalFull(parseFloat(list[i].goodsUnitPrice)),
          // 含税单价
          unitprice: keepTwoDecimalFull(parseFloat(list[i].goodsUnitPrice) * (1 + rate)),
          goodsPriceAmounts: keepTwoDecimalFull(parseFloat(list[i].goodsPriceAmounts)),
          unitmoney: keepTwoDecimalFull(parseFloat(list[i].goodsPriceAmounts) * (1 + rate)),
          goodsTaxRates: rate,
          taxAmountPayables: keepTwoDecimalFull(parseFloat(list[i].taxAmountPayables)).toFixed(2),
          hasTax: '',
        }
        listData.push(sublist)
      }
      return listData
    },
    // 发票保存
    printSave: _.throttle(async function (taxClass) {
      const dataDetail = this.getParam()
      if (dataDetail === undefined || dataDetail === null) return
      // 总价为负数则任务是开负数
      if (Number(this.rateMoneyAmount) < 0) {
        const task = Utils.getTaskDataByModType('8')
        if (checkObjectOfNull(task)) {
          this.$error({
            title: '警告',
            content: '暂无负数发票业务!',
          })
          return
        } else {
          this.taskData = task
        }
      }
      this.isSaving = true
      const params = parseParam({
        moduleId: this.taskData.id,
        icManageId: this.kpdate.icManageId ? this.kpdate.icManageId : '',
        taxClass: this.kpdate.taxClass,
        isTax: this.price === 'price' ? 1 : 0,
        data: JSON.stringify(dataDetail),
        detailId: this.detailId,
      })
      const res = await this.$http.post(`${Urls.saveInvoice}&${params}`)
      if (res) {
        this.onlyQd = false
        await this.uploadTestByOSS({ result: res, isFinish: '2' })
        await this.getBusinessList()
        if (taxClass === 3) {
          this.showEleInvoice() // 显示电子发票开具成功界面
        } else {
          this.showPrint() // 显示打印框
          this.invoiceId = res.invoiceId
        }
        this.isSaving = false
      } else {
        this.$error({
          title: '警告',
          content: res.msg,
        })
        this.isSaving = false
      }
    }),
    // async printSave(taxClass) {

    // },
    getParam() {
      const studentReportTaxBList = []
      if (this.onlyQd === true) {
        this.isMenu = 'Y'
        Object.assign(studentReportTaxBList, this.detailedList)
      } else {
        Object.assign(studentReportTaxBList, this.kpList)
      }
      let params = {
        id: '',
        taxBillCode: this.kpdate.taxBillCode,
        taxBillNo: this.kpdate.taxBillNo,
        taxBillDate: this.enterprise.taxBillDate,
        buyerName: this.enterprise.buyerName,
        buyerTaxpayerId: this.enterprise.buyerTaxpayerId,
        buyerAddress: this.enterprise.buyerAddress,
        buyerAccounts: this.enterprise.buyerAccounts,
        totalGoodsPrices: Number(this.moneyAmount),
        totalTaxPays: Number(this.rateMoneyAmount),
        totalLowerPrices: Number(this.rateMoneyAmount + this.moneyAmount),
        enterpriseName: this.enterprise.enterpriseName,
        enterpriseTaxpayerId: this.enterprise.enterpriseTaxpayerId,
        enterpriseAddress: this.enterprise.enterpriseAddress,
        enterpriseAccounts: this.enterprise.enterpriseAccounts,
        remark: this.enterprise.remake,
        drawer: this.enterprise.drawer,
        rechecker: this.enterprise.rechecker,
        payee: this.enterprise.payee,
        isMenu: this.isMenu,
        stuId: this.LOGIN_INFO.stuId,
        enterpriseId: this.LOGIN_INFO.eid,
        studentReportTaxBList: studentReportTaxBList,
      }
      // 保存的时候做字段校验
      if (!this.enterprise.buyerName) {
        this.$error({
          title: '警告',
          content: '购方姓名为空',
        })
        return
      }
      const list = params.studentReportTaxBList
      if (list.length <= 0) {
        this.$error({
          title: '警告',
          content: '请先添加商品',
        })
        return
      }
      for (let i = 0; i < list.length; i++) {
        if (!list[i].goodsName) {
          this.$error({
            title: '警告',
            content: '第' + (i + 1) + '行货物或应税劳务，服务名称不能为空',
          })
          return
        } else if (!list[i].isDiscount && !list[i].goodsAmounts) {
          this.$error({
            title: '警告',
            content: '第' + (i + 1) + '行数量不能为空',
          })
          return
        } else if (!list[i].isDiscount && !list[i].goodsUnitPrice) {
          this.$error({
            title: '警告',
            content: '第' + (i + 1) + '行单价不能为空',
          })
          return
        } else if (!list[i].isDiscount && !list[i].goodsPriceAmounts) {
          this.$error({
            title: '警告',
            content: '第' + (i + 1) + '行金额不能为空',
          })
          return
        } else if (!list[i].goodsTaxRates) {
          console.log(list[i].goodsTaxRates)
          this.$error({
            title: '警告',
            content: '第' + (i + 1) + '行税率不能为空',
          })
          return
        }
      }
      if (this.price !== 'taxfree') {
        // 当前数据为不含税数据
        this.priceChange()
        params = this.getParam()
      }
      return params
    },
    changStatusFinish() {},
    // 显示电子发票开具成功界面
    showEleInvoice() {
      this.eleInvoiceShow = true
    },
    closeEleInvoice() {
      this.handelCancel()
      this.eleInvoiceShow = false
    },
    // 电子发票继续开具按钮
    async keepOpen(taxClass) {
      this.visible = false
      this.kpdate.taxClass = taxClass
      const isOpen = await this.nextFptk()
      if (isOpen) {
        this.generateInvoice()
        this.visible = true
      }
      this.closeEleInvoice()
    },
    // 显示打印弹框
    showPrint() {
      this.isInPrint = true
      this.$refs.printModal.show()
    },
    // 关闭打印弹框
    closePrint() {
      this.isInPrint = false
      this.$refs.printModal.close()
    },
    // emitClosePrint() {
    //   this.closePrint()
    // },
    // 点击打印/不打印
    async printFpChange(type) {
      const params = parseParam({
        invoiceId: this.invoiceId,
        isPrin: type,
      })
      const res = await this.$http.post(`${Urls.updateInvoice}&${params}`)
      if (res) {
        if (type === 'N') {
          this.$info({
            title: '提示',
            content: '不打印，但数据已经保存！',
          })
        } else if (type === 'Y') {
          this.$print(this.$refs.invoice)
        }
        this.closePrint()
      }
      this.handelCancel() // 关闭弹框
    },
    ...mapActions('practice', ['getTaskByInvoice', 'getBusinessList', 'uploadTestByOSS']),
  },
}
</script>

<style lang="less" scoped>
@left: 15px;
@top: 5px;
.wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  color: #000;
  .header {
    padding: 5px;
    background-color: #5eb2f8;
    color: #fff;
    font-size: 12px;
  }
}
.main {
  background-color: #e4e7fa;
  flex: 1;
  .main-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px;
    height: 37px;
    button {
      margin: 0 5px;
    }
  }
}
.main-cont {
  display: flex;
  flex: 1;
  justify-content: space-around;
  .cont-invoice {
    &.pt {
      background-image: url('~@/assets/invoice-pt.png');
    }
    &.zy {
      background-image: url('~@/assets/invoice-zy.png');
    }
    &.dz {
      background-image: url('~@/assets/invoice-dzpt.png');
    }
    // width: 1137px;
    // height: 665px;
    width: 878px;
    height: 500px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin: 5px;
    position: relative;
    .invoice-header {
      height: 78px;
      display: block;
      font-size: 22px;
      font-family: '宋体';
      font-weight: 700;
      border: none;
      color: #9d5426;
      position: relative;
      span {
        position: absolute;
        // top: 38px;
        top: @top + 24px;
      }
    }
    .invoice-no {
      // margin-top: 30px;
      .code {
        // margin-left: 164px;
        position: absolute;
        left: @left + 103px;
        top: @top + 80px;
        transform: scale(0.75);
      }
      .number {
        // margin-left: 69px;
        // position: absolute;
        // left: 362px;
        position: absolute;
        left: @left + 280px;
        top: @top + 80px;
        transform: scale(0.8);
      }
      .version {
        // text-align: right;
        // margin-right: 109px;
        position: absolute;
        top: @top + 57px;
        right: 69px;
        color: #c7c7c7;
        font-size: 12px;
        transform: scale(0.9);
      }
      .date {
        // display: inline-block;
        // position: absolute;
        // left: 944px;
        display: inline-block;
        position: absolute;
        right: 63px;
        top: @top + 70px;
        transform: scale(0.8);
      }
    }
    .invoice-buyer {
      input[type='text'] {
        border: 1px solid #a2ddfb;
        display: block;
      }
      .left {
        display: inline-block;
        position: absolute;
        left: @left + 102px;
        top: @top + 87px;
        transform: scale(0.7);
        input {
          width: 430px;
          margin-bottom: 2px;
        }
      }
      .right {
        display: inline-block;
        /* margin-left: 79px; */
        position: absolute;
        top: @top + 112px;
        left: @left + 490px;
        transform: scale(0.7);
        input {
          width: 347px;
        }
      }
    }
    .invoice-table {
      // width: 83.4%;
      // margin-left: 8.3%;
      // margin-top: 3px;
      min-height: 189px;
      font-size: 12px;
      transform: scale(0.835);
      position: absolute;
      top: @top + 165px;
      &.unborder {
        .tab {
          display: flex;
          height: 19px;
          > div {
            border: none;
            box-sizing: border-box;
            width: 100%;
          }
        }
      }
      .tab {
        display: flex;
        height: 19px;
        > div {
          border: 1px solid #a2ddfb;
          box-sizing: border-box;
          width: 100%;
        }
      }
      .table-header {
        text-align: center;
        background-color: #cee3f4;
      }
      .table-content {
        input[type='text'],
        input[type='number'],
        select {
          width: 100%;
          height: 100%;
          border: none;
          background-color: transparent;
        }
      }
    }
    .invoice-sum {
      // height: 36px;
      // line-height: 36px;
      font-weight: 500;
      :first-child {
        position: absolute;
        left: @left + 519px;
        top: @top + 324px;
        transform: scale(0.8);
      }
      :nth-child(2) {
        position: absolute;
        left: @left + 698px;
        top: @top + 324px;
        transform: scale(0.8);
      }
    }
    .invoice-taxsum {
      height: 36px;
      line-height: 36px;
      font-weight: 500;
      :first-child {
        position: absolute;
        top: @top + 342px;
        left: @left + 250px;
        transform: scale(0.8);
      }
      :nth-child(2) {
        position: absolute;
        top: @top + 342px;
        left: @left + 655px;
        transform: scale(0.8);
      }
    }
    .invoice-saler {
      display: flex;
      input[type='text'] {
        border: 1px solid #a2ddfb;
        display: block;
        height: 23px;
      }
      .left {
        // margin-left: 237px;
        // margin-top: 2px;
        position: absolute;
        transform: scale(0.7);
        left: @left + 90px;
        top: @top + 365px;
        input {
          width: 503px;
        }
      }
      .right {
        // margin-left: 27px;
        width: 350px;
        height: 95px;
        position: absolute;
        left: @left + 493px;
        top: @top + 364px;
        transform: scale(0.7);
        textarea {
          height: 100%;
          width: 100%;
          padding: 0;
        }
      }
    }
    .invoice-footer {
      display: flex;
      align-items: center;
      margin-top: 3px;
      .payee {
        // margin-left: 187px;
        position: absolute;
        top: @top + 446px;
        left: @left + 106px;
        transform: scale(0.7);
      }
      .review {
        position: absolute;
        // left: 442px;
        top: @top + 446px;
        left: @left + 275px;
        transform: scale(0.7);
        input {
          width: 150px;
        }
      }
      .billing {
        // position: absolute;
        // top: 604px;
        // left: 664px;
        position: absolute;
        top: @top + 448px;
        left: @left + 465px;
        transform: scale(0.8);
        font-weight: 500;
      }
      input[type='text'] {
        border: 1px solid #a2ddfb;
      }
    }
  }
  .cont-op {
    display: flex;
    flex-direction: column;
    padding: 3px;
    justify-content: center;
    button {
      margin: 5px 0;
    }
  }
}
.discountWrap {
  padding: 5% 10%;
  color: #000;
  .row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    .left,
    .right {
      width: 45%;
      font-size: 16px;
    }
    .left {
      text-align: right;
    }
    .right {
      text-align: left;
    }
  }
}
.addImg {
  position: absolute;
  right: 6px;
  top: 5px;
  color: #16affd;
}
.relative {
  position: relative;
}
.eleInvocie {
  height: 100%;
  .eHeader {
    height: 23%;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .QRcode {
    width: 150px;
    height: 150px;
    margin: 0 auto;
  }
  .eFooter {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 20px;
  }
}
.unborder {
  appearance: none !important;
  border: none !important;
}
</style>
<style lang="less">
.wrap {
  .main-top,
  .main-cont {
    .ant-btn-background-ghost {
      background-color: #fff !important;
    }
  }
}
</style>
